import { createSlice } from "@reduxjs/toolkit";
import { getUserReview, createReview, deleteReview } from "./reviewThunk";

const initialState = {
  userReview: null,
  loading: false,
  error: null,
};

const reviewSlice = createSlice({
  name: "reviews",
  initialState,
  reducers: {
    clearReview: (state) => {
      state.userReview = null;
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // دریافت امتیاز کاربر
      .addCase(getUserReview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserReview.fulfilled, (state, action) => {
        state.loading = false;
        state.userReview = action.payload;
      })
      .addCase(getUserReview.rejected, (state, action) => {
        state.loading = false;
        state.userReview = null;
        state.error = action.payload?.detail || "خطا در دریافت امتیاز";
      })
      // ایجاد/به‌روزرسانی امتیاز
      .addCase(createReview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createReview.fulfilled, (state, action) => {
        state.loading = false;
        state.userReview = action.payload;
      })
      .addCase(createReview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.detail || "خطا در ثبت امتیاز";
      })
      // حذف امتیاز
      .addCase(deleteReview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteReview.fulfilled, (state) => {
        state.loading = false;
        state.userReview = null;
        state.error = null;
      })
      .addCase(deleteReview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.detail || "خطا در حذف امتیاز";
      });
  },
});

export const { clearReview } = reviewSlice.actions;
export default reviewSlice.reducer;